var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#help-outline_svg__clip0_245_2320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19a1 1 0 100-2 1 1 0 000 2zM10.257 7.474c.845-.373 1.81-.532 2.625-.455.84.079 1.332.38 1.537.711.496.803.3 1.923-1.024 3.046C11.913 12.03 11 12.993 11 14.5a1 1 0 102 0c0-.493.17-.912 1.688-2.198 1.674-1.42 2.687-3.594 1.433-5.623-.67-1.084-1.897-1.543-3.052-1.651-1.178-.111-2.485.115-3.62.617a1 1 0 00.808 1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "help-outline_svg__clip0_245_2320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgHelpOutline;